import React, { Component } from 'react'
import { Route, Switch, Redirect } from 'react-router-dom';

import CancelacionesList from './CancelacionesList';
import GuardianRoute from '../../shared/GuardianRoute';
import CancelacionesTickets from './CancelacionesTickets';

class Cancelaciones extends Component {

  render() {
    return (
      <>
        <Switch>
          <Redirect from="/modulos/cancelaciones" to="/modulos/cancelaciones/tickets" exact />
          <GuardianRoute
            path="/modulos/cancelaciones/archivos"
            component={ CancelacionesList }
            can="cancelacion.masiva.listar.archivos"
          />
          <GuardianRoute
            path="/modulos/cancelaciones/tickets"
            component={ CancelacionesTickets }
            can="cancelacion.masiva.listar.tickets"
            exact
          />
          <Route path="/modulos/cancelaciones/tickets/:uuid/info" component={ CancelacionesList } exact />
        </Switch>
      </>
    )
  }
}

export default Cancelaciones;